import { render, staticRenderFns } from "./DurationEdit.vue?vue&type=template&id=50e489d2&scoped=true"
import script from "./DurationEdit.vue?vue&type=script&lang=js"
export * from "./DurationEdit.vue?vue&type=script&lang=js"
import style0 from "./DurationEdit.vue?vue&type=style&index=0&id=50e489d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e489d2",
  null
  
)

export default component.exports